module.exports = __webpack_public_path__ + "img/user.0c3772f5.svg";